import { SET_DYNAMIC_BREADCRUMS, SET_FEATURES, SET_VIRUS_SCAN_STATUS } from '../actionTypes/configurationActionTypes';
import { FeaturesConfig } from '../types/ConfigState';

export interface BreadcrumbItem {
  title: string;
  path: string;
}

export interface ConfigState {
  dynamicBreadcrumValues: BreadcrumbItem[] | string[];
}

export const setDynamicBreadcrums = (data: any[]) => {
  return {
    type: SET_DYNAMIC_BREADCRUMS,
    payload: data,
  };
};

export const setFeatures = (features: FeaturesConfig) => {
  return {
    type: SET_FEATURES,
    payload: features,
  };
};

export const setVirusScanStatus = (enabled: boolean) => {
  return {
    type: SET_VIRUS_SCAN_STATUS,
    payload: enabled,
  };
};
